import { useEffect, useState } from "react"
import {audioUserUploadURL, audioBaseURL} from "../../constants"


function SafeAudio ({ filename }){
  const [altSources, setAltSources] = useState()

  useEffect(() => {
    setAltSources([
      audioUserUploadURL + filename,
    ])
}, [])
    
      const onAudioError = (e) => {
        let currentSrc = ""
        if(altSources.length > 0){
            currentSrc = altSources.shift()
        }
        e.currentTarget.src = currentSrc
    }
    
    
      return (
        <div className="audio">
            <audio controls src={audioBaseURL + filename} onError={(e) => (onAudioError(e))}></audio>
        </div>

      )
    }
    
    export default SafeAudio